import { memo } from 'react';
import Link from 'next/link';
import useNavigateWithAnimation from '@/helpers/useNavigateWithAnimation';

function ActionLink({
    children,
    to = null,
    state,
    className,
    onClick,
    // replace,
    style,
    draggable = 'false',
    replace = false,
    ...props
}) {
    const { navigateWithAnimation } = useNavigateWithAnimation();
    const go = (e) => {
        if (to) {
            e.preventDefault();
            navigateWithAnimation({ link: to, state, replace });
        }
        onClick?.(e);
    };

    return (
        <Link
            tabIndex="-1"
            href={to || '#'}
            // state={state}
            style={style}
            draggable={draggable}
            onClick={go}
            className={className}
            {...props}>
            {children}
        </Link>
    );
}

export default memo(ActionLink);
